import React, { FC, useMemo, useRef, useState } from 'react';

import { Column, FilterRow, Pager, Paging } from 'devextreme-react/data-grid';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { Button, DataGrid } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { CreateEditModal, DeleteModal } from './components';

const TransportOverRateMixer: FC = () => {
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [modalIsVisibleDelete, setModalIsVisibleDelete] = useState(false);
  const [detailId, setDetailId] = useState<number | null>(null);

  const requestDateSource = useMemo(() => {
    return $createStore('/v1/MixerOverRate', 'id');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);

  const refresh = () => refGrid.current?.instance.refresh();

  const handleChangeVisibleDetail = (visible) => {
    if (!visible) {
      setDetailId(null);
    }
    setModalIsVisible(visible);
  };

  const handleChangeVisible = (visible) => {
    if (!visible) {
      setDetailId(null);
    }
    setModalIsVisibleDelete(visible);
  };

  return (
    <div className="container-dev">
      {modalIsVisible && (
        <CreateEditModal
          changeVisible={handleChangeVisibleDetail}
          visible={modalIsVisible}
          refresh={refresh}
          id={detailId}
        />
      )}
      {modalIsVisibleDelete && (
        <DeleteModal
          changeVisible={handleChangeVisible}
          visible={modalIsVisibleDelete}
          refresh={refresh}
          detailId={detailId}
        />
      )}

      <AppLayoutTop title="Повышенная ставка миксера">
        <ClaimsProvider claimsBlock={['CanCreateTransportOverRate']}>
          <Button width={120} text="Создать" type="default" onClick={() => setModalIsVisible(true)} />
        </ClaimsProvider>
      </AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={requestDateSource as any}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
        >
          <FilterRow visible={true} />

          <Column dataField="transport" caption="Транспорт" />
          <Column dataField="sum" caption="Сумма" />
          <Column dataField="dateBegin" caption="Дата начала" dataType="date" />
          <Column dataField="dateEnd" caption="Дата окончания" dataType="date" />

          <Column
            dataField="actions"
            caption=""
            width={120}
            cellRender={(data) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditTransportOverRate']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setDetailId(data.data.id);
                      setModalIsVisible(true);
                    }}
                  />
                </ClaimsProvider>
                <ClaimsProvider claimsBlock={['CanDeleteTransportOverRate']}>
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setDetailId(data.data.id);
                      setModalIsVisibleDelete(true);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default TransportOverRateMixer;
